// const imgLocation = "https://slgold.algo2bot.com/ajax/images/";
// const imgLocation = "http://localhost/Project/ecommere_react_with_php_main/ecommere_react_with_php_main/ajax/images/";
// 
const imgLocation = "https://luxaddi.algo2bots.com/ajax/images/";




export default  imgLocation ;
